const MainCourseIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.75131 4.16675C7.35035 4.16675 5.98086 4.58218 4.81602 5.36051C3.65117 6.13883 2.74328 7.2451 2.20716 8.53941C1.67104 9.83372 1.53076 11.2579 1.80408 12.632C2.07739 14.006 2.75201 15.2681 3.74263 16.2588C4.73325 17.2494 5.99538 17.924 7.36942 18.1973C8.74345 18.4706 10.1677 18.3303 11.462 17.7942C12.7563 17.2581 13.8626 16.3502 14.6409 15.1854C15.4192 14.0205 15.8346 12.651 15.8346 11.2501C15.8346 10.8584 15.5146 10.5342 15.1305 10.6117C14.3296 10.7742 13.6095 11.2087 13.0924 11.8414C12.5752 12.4741 12.2928 13.2662 12.293 14.0834M8.75131 4.16675H14.418C15.2005 4.16675 15.853 4.81091 15.6596 5.56925C15.348 6.78908 14.6391 7.87041 13.6446 8.64256C12.6502 9.41471 11.427 9.8337 10.168 9.83341H8.75131C8.18772 9.83341 7.64722 10.0573 7.2487 10.4558C6.85019 10.8543 6.6263 11.3948 6.6263 11.9584C6.6263 12.522 6.85019 13.0625 7.2487 13.461C7.64722 13.8595 8.18772 14.0834 8.75131 14.0834H12.293M8.75131 4.16675V7.00008M12.293 14.0834V14.7917M4.50131 16.9167L7.33464 14.0834M2.73047 7.70841L6.6263 10.8959M11.2513 6.66675H11.2438"
				stroke="currentColor"
				strokeWidth="0.833333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.5 1.66675H16.8C17.7675 1.66675 18.4925 2.54258 18.3033 3.48175C18.0575 4.69841 16.9533 5.56508 15.7658 5.83341"
				stroke="currentColor"
				strokeWidth="0.833333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default MainCourseIcon;
